import { gql } from 'apollo-angular';
import { buildConnectionQuery } from "../../../helpers.class";

export const nodeFragment = `
    id
    name
`;

export const addressTypeQuery = gql`${buildConnectionQuery("AddressType", "addressTypeConnection", nodeFragment)}`;